import LocalStorage from './LocalStorage';

class DataController {
  constructor() {
    this.storage = new LocalStorage();
    this.filterKey = 'filter';
  }

  upsertFilter(filter) {
    const existingFilter = this.getFilter();
    const updatedFilter = { ...existingFilter, ...filter };
    this.storage.set(this.filterKey, updatedFilter);
  }

  getFilter() {
    return this.storage.get(this.filterKey, {});
  }
}

export default DataController;
